import * as zod from 'zod';

import { Expression } from '../../types';

const CaptureConfig = zod.object({
  saveEquipmentId: zod.string(),
  saveFilepath: Expression,
  saveMetadata: zod.boolean().default(false),
});

const Arguments = zod.object({
  skillId: zod.string(),
  positionListName: zod.string().optional(),
  captureConfig: CaptureConfig.optional(),
  // Deploy-time override of a text_prompt skill's `textInput`. Either a literal
  // string (typed in the step) or an Expression resolved to a string at run
  // time (e.g. a routine variable). Empty/omitted = use the prompt saved on the
  // skill. Ignored for non-text_prompt methods.
  textPromptOverride: zod.union([zod.string(), Expression]).optional(),
});

export default Arguments;
